/**
 * Security hold banner (0079). Unlike the compliance suspension, the CLIENT raised
 * this hold (the "this wasn't me" link), so the copy says plainly what happened and
 * what ends it. Informational, no urgency styling, no dismiss: it goes away when a
 * manager lifts the hold after verifying the holder's identity.
 */
import { useCurrentUserProfile } from '../../hooks/useCurrentUserProfile';
import { colors } from '../../styles/theme';

export default function SecurityHoldBanner(): JSX.Element | null {
  const profile = useCurrentUserProfile();
  if (!profile?.security_hold) return null;

  return (
    <aside
      role="status"
      aria-live="polite"
      className="rounded-lg p-3 mb-4"
      style={{ background: colors.warningBg, border: '1px solid #FCD34D' }}
    >
      <p className="text-sm font-semibold mb-1" style={{ color: colors.warning }}>
        Your account is under a security hold
      </p>
      <p className="text-xs" style={{ color: colors.ink }}>
        A change to your account was reported as unauthorised. Withdrawals and account
        changes are frozen until our team has verified your identity with you. Your
        balances and contributions are not affected. If you have not heard from us, please
        contact support.
      </p>
    </aside>
  );
}
